import { render, staticRenderFns } from "./DirectoryOrderTable.vue?vue&type=template&id=dc2bd790&scoped=true&"
import script from "./DirectoryOrderTable.vue?vue&type=script&lang=js&"
export * from "./DirectoryOrderTable.vue?vue&type=script&lang=js&"
import style0 from "./DirectoryOrderTable.vue?vue&type=style&index=0&id=dc2bd790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2bd790",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc2bd790')) {
      api.createRecord('dc2bd790', component.options)
    } else {
      api.reload('dc2bd790', component.options)
    }
    module.hot.accept("./DirectoryOrderTable.vue?vue&type=template&id=dc2bd790&scoped=true&", function () {
      api.rerender('dc2bd790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/directories/DirectoryOrderTable.vue"
export default component.exports